module.exports = __webpack_public_path__ + "media/categories/29v-41c0802d.svg";